// Maps the field definition types to stringifiers

import DataFieldCache from "@/models/data.field.cache";
import {
    DateStringifier,
    DefaultStringifier, DisplayValueStringifier,
    EnumerationStringifier,
    LabValueStringifier, ListEntryStringifier,
    ScaleStringifier,
    ValueWithUnitStringifier
} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";

export default {
    'Default':  (field: DataFieldCache | ReadonlyDataField) => DefaultStringifier(field),
    'Date': (field: DataFieldCache | ReadonlyDataField) => DateStringifier(field),
    'MedicalDate': (field: DataFieldCache | ReadonlyDataField) => DateStringifier(field),
    'Enumeration': (field: DataFieldCache | ReadonlyDataField) => EnumerationStringifier(field),
    'LabValue': (field: DataFieldCache | ReadonlyDataField) => LabValueStringifier(field),
    'MultiRangeLabValue': (field: DataFieldCache | ReadonlyDataField) => LabValueStringifier(field),
    'Decimal': (field: DataFieldCache | ReadonlyDataField) => ValueWithUnitStringifier(field),
    'Integer': (field: DataFieldCache | ReadonlyDataField) => ValueWithUnitStringifier(field),
    'Scale':  (field: DataFieldCache | ReadonlyDataField) => ScaleStringifier(field),
    'FreeText':  (field: DataFieldCache | ReadonlyDataField) => DefaultStringifier(field),
    'ListEntry': (field: DataFieldCache | ReadonlyDataField) => ListEntryStringifier(field),
    'DisplayValue':  (field: DataFieldCache | ReadonlyDataField) => DisplayValueStringifier(field),
}

/*
Example extensions
'Test': () => (field: DataFieldCache) => field.values.value?.toString(),

or
'Test': () => TestStringifier,

export const TestStringifier :IStringifier = function (field: DataFieldCache): string {
    return field.values.value?.toString();
}
*/
